<template>
  <div class="contents">
    <div class="layout">
      <div class="breadcrumb">
        <div class="breadcrumb-item">기업 관리</div>
        <div class="breadcrumb-item active">기업 관리</div>
      </div>

      <div class="page-header">
        <h1 class="page-title">기업 관리</h1>
        <div class="page-actions">
          <button
            v-permission="'ADMIN_WRITE'"
            @click="openCreateModal"
            class="btn btn-primary"
          >
            <i class="icon-plus"></i>
            기업 추가
          </button>
        </div>
      </div>

      <div class="white-panel mt20">
        <div class="table-wrap">
          <div class="scroll-box">
            <table class="table-type1">
              <colgroup>
                <col style="width: 5%" />
                <!-- NO -->
                <col style="width: 20%" />
                <!-- 기업명 -->
                <col style="width: 15%" />
                <!-- 유형 -->
                <col style="width: 15%" />
                <!-- 연락처 -->
                <col style="width: 20%" />
                <!-- 이메일 -->
                <col style="width: 10%" />
                <!-- 생성일 -->
                <col style="width: 15%" />
                <!-- 액션 -->
              </colgroup>
              <thead>
                <tr>
                  <th>NO</th>
                  <th>기업명</th>
                  <th>유형</th>
                  <th>연락처</th>
                  <th>이메일</th>
                  <th>생성일</th>
                  <th>관리</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(organization, index) in organizations"
                  :key="organization.id"
                >
                  <td>{{ index + 1 }}</td>
                  <td>
                    <div>
                      <div class="font-weight-bold">
                        {{ organization.name }}
                      </div>
                      <div
                        v-if="organization.description"
                        class="text-muted text-sm"
                      >
                        {{ organization.description }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <span class="badge badge-info">
                      {{ organization.organizationType }}
                    </span>
                  </td>
                  <td>{{ organization.phoneNumber || '-' }}</td>
                  <td>{{ organization.email || '-' }}</td>
                  <td>{{ formatDate(organization.createdAt) }}</td>
                  <td>
                    <div class="action-buttons">
                      <button
                        v-permission="'ADMIN_WRITE'"
                        @click="openEditModal(organization)"
                        class="btn-sm btn-outline"
                      >
                        수정
                      </button>
                      <button
                        v-permission="'ADMIN_DELETE'"
                        @click="confirmDelete(organization)"
                        class="btn-sm btn-danger"
                      >
                        삭제
                      </button>
                    </div>
                  </td>
                </tr>
                <tr v-if="organizations.length === 0">
                  <td colspan="7" class="text-center text-muted">
                    등록된 기업이 없습니다.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- 기업 생성/수정 모달 -->
      <div v-if="showModal" class="modal-overlay" @click="closeModal">
        <div class="modal-content" @click.stop>
          <div class="modal-header">
            <h3>{{ modalMode === 'create' ? '기업 추가' : '기업 수정' }}</h3>
            <button @click="closeModal" class="modal-close">&times;</button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submitForm">
              <div class="form-group">
                <label for="name">기업명 *</label>
                <input
                  id="name"
                  v-model="form.name"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.name }"
                  required
                  maxlength="255"
                />
              </div>
              <div class="form-group">
                <label for="organizationType">조직유형 *</label>
                <select
                  id="organizationType"
                  v-model="form.organizationType"
                  class="form-control"
                  :class="{ 'is-invalid': errors.organizationType }"
                  required
                >
                  <option value="">조직유형을 선택하세요</option>
                  <option
                    v-for="option in ORGANIZATION_TYPE_OPTIONS"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.label }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label for="address">주소</label>
                <div class="address-input-group">
                  <button
                    type="button"
                    @click="handleSearchAddress"
                    class="btn btn-outline address-search-btn"
                  >
                    도로명 주소 검색
                  </button>
                  <input
                    id="address"
                    v-model="form.address"
                    type="text"
                    class="form-control"
                    maxlength="255"
                    placeholder="주소 검색 버튼을 클릭하세요"
                    readonly
                  />
                </div>
              </div>
              <div class="form-group">
                <label for="phoneNumber">연락처</label>
                <input
                  id="phoneNumber"
                  v-model="form.phoneNumber"
                  type="tel"
                  class="form-control"
                  maxlength="40"
                />
              </div>
              <div class="form-group">
                <label for="email">이메일</label>
                <input
                  id="email"
                  v-model="form.email"
                  type="email"
                  class="form-control"
                  maxlength="255"
                />
              </div>
              <div class="form-group">
                <label for="websiteUrl">웹사이트</label>
                <input
                  id="websiteUrl"
                  v-model="form.websiteUrl"
                  type="url"
                  class="form-control"
                  maxlength="255"
                  placeholder="https://example.com"
                />
              </div>
              <div class="form-group">
                <label for="description">설명</label>
                <textarea
                  id="description"
                  v-model="form.description"
                  class="form-control"
                  rows="3"
                  maxlength="255"
                ></textarea>
              </div>
              <div class="form-group">
                <label for="memo">메모</label>
                <textarea
                  id="memo"
                  v-model="form.memo"
                  class="form-control"
                  rows="3"
                  maxlength="255"
                ></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button @click="closeModal" class="btn btn-secondary">취소</button>
            <button @click="submitForm" class="btn btn-primary">
              {{ modalMode === 'create' ? '추가' : '수정' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, reactive } from 'vue'
import { apiClient } from '@/services/auth-header'
import { useToast } from '@/composables/useToast'
import { formatDate, searchAddress } from '@/common/common-function'
import { ORGANIZATION_TYPE_OPTIONS } from '@/constants/organization'
import { useModal } from '@/composables/useModal'

const toast = useToast()


// 데이터
const organizations = ref([])

// 모달 관련
const { showModal, modalMode, openCreateModal: baseOpenCreateModal, openEditModal: baseOpenEditModal, closeModal: baseCloseModal } = useModal()
const form = reactive({
  id: null,
  name: '',
  organizationType: '',
  address: '',
  phoneNumber: '',
  email: '',
  websiteUrl: '',
  description: '',
  memo: '',
})
const errors = ref({})

// 페이지 로드 시 데이터 조회
onMounted(async () => {
  await fetchOrganizations()
})

// 기업 목록 조회
const fetchOrganizations = async () => {
  try {
    const response = await apiClient.get('/organizations')
    organizations.value = response.data
  } catch (error) {
    toast.error('기업 목록을 불러오는데 실패했습니다.')
  }
}

// 생성 모달 열기
const openCreateModal = () => {
  baseOpenCreateModal()
  resetForm()
}

// 수정 모달 열기
const openEditModal = organization => {
  baseOpenEditModal()
  errors.value = {}
  form.id = organization.id
  form.name = organization.name
  form.organizationType = organization.organizationType
  form.address = organization.address || ''
  form.phoneNumber = organization.phoneNumber || ''
  form.email = organization.email || ''
  form.websiteUrl = organization.websiteUrl || ''
  form.description = organization.description || ''
  form.memo = organization.memo || ''
}

// 모달 닫기
const closeModal = () => {
  baseCloseModal()
  resetForm()
}

// 폼 초기화
const resetForm = () => {
  form.id = null
  form.name = ''
  form.organizationType = ''
  form.address = ''
  form.phoneNumber = ''
  form.email = ''
  form.websiteUrl = ''
  form.description = ''
  form.memo = ''
  errors.value = {}
}

const validateForm = () => {
  const newErrors = {}
  if (!form.name || !form.name.trim()) newErrors.name = true
  if (!form.organizationType) newErrors.organizationType = true
  errors.value = newErrors
  return Object.keys(newErrors).length === 0
}

// 폼 제출
const submitForm = async () => {
  if (!validateForm()) {
    toast.error('필수 입력 항목을 확인해주세요.')
    return
  }

  try {
    const formData = {
      name: form.name,
      organizationType: form.organizationType,
      address: form.address || null,
      phoneNumber: form.phoneNumber || null,
      email: form.email || null,
      websiteUrl: form.websiteUrl || null,
      description: form.description || null,
      memo: form.memo || null,
    }

    if (modalMode.value === 'create') {
      await apiClient.post('/organizations', formData)
      toast.success('기업이 성공적으로 추가되었습니다.')
    } else {
      await apiClient.put(`/organizations/${form.id}`, formData)
      toast.success('기업 정보가 성공적으로 수정되었습니다.')
    }

    closeModal()
    await fetchOrganizations()
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      (modalMode.value === 'create'
        ? '기업 추가에 실패했습니다.'
        : '기업 수정에 실패했습니다.')
    toast.error(errorMessage)
  }
}

// 삭제 확인
const confirmDelete = organization => {
  if (confirm(`'${organization.name}' 기업을 삭제하시겠습니까?`)) {
    deleteOrganization(organization.id)
  }
}

// 기업 삭제
const deleteOrganization = async id => {
  try {
    await apiClient.delete(`/organizations/${id}`)
    toast.success('기업이 성공적으로 삭제되었습니다.')
    await fetchOrganizations()
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || '기업 삭제에 실패했습니다.'
    toast.error(errorMessage)
  }
}

// 주소 검색
const handleSearchAddress = async () => {
  try {
    const data = await searchAddress()
    form.address = data.address
  } catch (error) {
    toast.error('주소 검색에 실패했습니다.')
  }
}

</script>

<style scoped>
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}

.page-actions {
  display: flex;
  gap: 10px;
}

.action-buttons {
  display: flex;
  gap: 5px;
  align-items: center;
}

.font-weight-bold {
  font-weight: 600;
}

.badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
}

.badge-info {
  background-color: #17a2b8;
  color: white;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #dee2e6;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-body {
  padding: 20px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 20px;
  border-top: 1px solid #dee2e6;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  color: #333;
}

.form-control {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-control:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.form-control.is-invalid {
  border-color: #dc3545;
}
.form-control.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

textarea.form-control {
  resize: vertical;
  min-height: 80px;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-danger {
  background-color: #dc3545;
  color: white;
}

.btn-outline {
  background-color: transparent;
  color: #007bff;
  border: 1px solid #007bff;
}

.btn-sm {
  padding: 4px 8px;
  font-size: 12px;
}

.text-center {
  text-align: center;
}

.text-muted {
  color: #6c757d;
}

.text-sm {
  font-size: 12px;
}

.mt20 {
  margin-top: 20px;
}

.white-panel {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.table-wrap {
  overflow-x: auto;
}

.scroll-box {
  min-height: 200px;
}

.table-type1 {
  width: 100%;
  border-collapse: collapse;
}

.table-type1 th,
.table-type1 td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #eee;
  vertical-align: middle;
}

.table-type1 th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #495057;
}

.breadcrumb {
  display: flex;
  margin-bottom: 20px;
  font-size: 14px;
}

.breadcrumb-item {
  color: #6c757d;
}

.breadcrumb-item:not(:last-child)::after {
  content: ' > ';
  margin: 0 8px;
}

.breadcrumb-item.active {
  color: #495057;
  font-weight: 500;
}

.contents {
  padding: 20px;
}

.layout {
  max-width: 1200px;
}

.address-input-group {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.address-search-btn {
  white-space: nowrap;
  min-width: 140px;
}
</style>